import { ImageElementAttributes } from '@/types';

export const jobBanner: ImageElementAttributes[] = [
  {
    src: '/job-banner/banner-1.png',
    alt: 'Kamil and Szymon',
    height: 381,
    width: 504
  },
  {
    src: '/job-banner/banner-2.png',
    alt: 'Kamil and Maciej',
    height: 377,
    width: 546
  },
  {
    src: '/job-banner/banner-3.png',
    alt: 'Jan and Maciej',
    height: 381,
    width: 522
  },
  {
    src: '/job-banner/banner-4.png',
    alt: 'Mateusz and Maciej',
    height: 389,
    width: 558
  },
  {
    src: '/job-banner/banner-5.png',
    alt: 'Kacper and Kamil',
    height: 373,
    width: 541
  },
  {
    src: '/job-banner/banner-6.png',
    alt: 'Mateusz and Maciej',
    height: 381,
    width: 503
  }
];
